import graphql__9ef8731a1eba9f15c2b5 from "./__generated__/AnswerPreview_answer.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import ShallowAnswerPreview from "./ShallowAnswerPreview";
import AnswerPreviewAddress from "./AnswerPreviewAddress";
import AnswerPreviewBudget from "./AnswerPreviewBudget";

const types = {
  AnswerPreviewAddress,
  AnswerPreviewBudget
};

const AnswerPreview = props => {
  const typename = "AnswerPreview" + props.answer.__typename.replace(/^Answer/, "");
  const isShallow = ShallowAnswerPreview.types[typename];
  const AnswerPreviewType = isShallow ? ShallowAnswerPreview : types[typename];

  return <AnswerPreviewType answer={props.answer} />;
};

export default createFragmentContainer(AnswerPreview, {
  answer: graphql__9ef8731a1eba9f15c2b5
});
